<template>
  <v-snackbar v-if="settingsNavigationNotice" :key="settingsNavigationNotice.id" :model-value="true"
    location="top" color="error" :timeout="6000" class="settings-navigation-notice"
    @update:model-value="!$event && clearSettingsNavigationNotice()">
    <div role="alert" aria-live="assertive">{{ settingsNavigationNotice.message || t('settingsAutosave.navigationIncomplete') }}</div>
    <template #actions>
      <v-btn icon="mdi-close" variant="text" size="small" :aria-label="t('common.actions.close')" @click="clearSettingsNavigationNotice" />
    </template>
  </v-snackbar>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { settingsNavigationNotice, clearSettingsNavigationNotice } from './navigationNotice'
const { t } = useI18n()
</script>
<style scoped>
.settings-navigation-notice :deep(.v-snackbar__wrapper) { max-width: min(640px, calc(100vw - 24px)); }
.settings-navigation-notice :deep(.v-snackbar__content) { white-space: normal; overflow-wrap: anywhere; }
</style>
